import { TableCell } from '@client/toolkit';
import classNames from 'classnames';

export function TableExpandableCell({
  label,
  onClick,
  onKeyDown,
  ariaLabel,
  isExpanded,
  icon,
  className,
}: {
  label: string;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  ariaLabel?: string;
  isExpanded: boolean;
  icon?: React.ReactNode;
  className?: string;
}) {
  return (
    <TableCell className={classNames('px-2 py-2 align-top flex justify-between items-center', className)}>
      <div
        role="button"
        onClick={onClick}
        onKeyDown={onKeyDown}
        aria-label={ariaLabel}
        className="flex items-center gap-2"
      >
        <svg
          className={`w-4 h-4 shrink-0 transition-transform ${isExpanded ? 'rotate-90' : ''}`}
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
        {label}
      </div>
      {icon && <span className="shrink-0">{icon}</span>}
    </TableCell>
  );
}
